import React, { useEffect } from "react";
import { useTable } from "react-table";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Link } from "react-router-dom";

import apiHelper from "../../../../util/ApiHelper";
import SubdirectoryArrowRightIcon from "@material-ui/icons/SubdirectoryArrowRight";
import { useLoading } from "../../../../util/LoadingProvider";

const useStyle = makeStyles({
  itemStatus: {
    color: "#306F9D",
    "&.archive": {
      color: "#962013",
    },
  },
});

function formatData(content) {
  const formattedData = content.map((row) => {
    return {
      id: row.id,
      enTitle: row.localizations.en.title,
      tcTitle: row.localizations.tc.title,
      slug: row.slug || "-",
      status: row.status,
      subRows: formatsubRowData(
        row.children,
        row.localizations.en.title === "Past Programme" ? "ARCHIVE" : row.status
      ),
    };
  });
  return formattedData;
}

function formatsubRowData(content, status) {
  if (content.length > 0) {
    const formattedData = content.map((row) => {
      return {
        enTitle: row.localizations.en.title,
        tcTitle: row.localizations.tc.title,
        slug: row.slug,
        status: status,
      };
    });
    return formattedData;
  }
  return;
}

class CustomTableCell extends React.Component {
  render() {
    return (
      <TableCell
        style={{ paddingTop: 12, paddingBottom: 12, ...this.props.style }}
        align={this.props.align}
        className={this.props.className}
      >
        {this.props.children}
      </TableCell>
    );
  }
}

function CustomTableRow(props) {
  const classes = useStyle();
  const { row, className } = props;
  console.log(row);
  return (
    <TableRow className={className}>
      <CustomTableCell component="th" scope="row">
        <Link
          to={`/cinefan/menu/edit/${row.id}`}
          style={{ textDecoration: "none", color: "#306F9D" }}
        >
          {row.enTitle}
        </Link>
      </CustomTableCell>
      <CustomTableCell align="left" style={{ color: "#306F9D" }}>
        {row.tcTitle}
      </CustomTableCell>
      <CustomTableCell
        align="left"
        className={`${classes.itemStatus} ${row.status.toLowerCase()}`}
      >
        {row.status.charAt(0).toUpperCase() + row.status.slice(1).toLowerCase()}
      </CustomTableCell>
      <CustomTableCell align="left">{row.slug}</CustomTableCell>
    </TableRow>
  );
}

export default function MenuTable(props) {
  const classes = useStyle();
  const [data, setData] = React.useState([]);
  const { setLoading } = useLoading();

  const getMenu = React.useCallback(async () => {
    setLoading(true);
    const result = await apiHelper.cinefan.getMenu();
    console.log(result);
    const formattedData = formatData(result.data);
    setData(formattedData);
    setLoading(false);
  }, [setLoading]);

  useEffect(() => {
    getMenu();
  }, [getMenu]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Title (English)",
        accessor: "enTitle",
      },
      {
        Header: "Title (Traditional)",
        accessor: "tcTitle",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Slug",
        accessor: "slug",
      },
    ],
    []
  );

  const defaultExpandedRows = [];
  for (let index = 0; index < 10; index++) {
    defaultExpandedRows.push({ index: true });
  }

  const { getTableProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
    initialState: { pageIndex: 0, expanded: defaultExpandedRows },
  });

  return (
    <>
      <Typography variant="h4" gutterBottom>
        Menu
      </Typography>
      <Paper>
        <Table aria-label="simple table" component="ul" {...getTableProps()}>
          <TableHead component="div">
            {headerGroups.map((headerGroup) => (
              <TableRow {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <TableCell
                    {...column.getHeaderProps()}
                    style={{ paddingTop: 12, paddingBottom: 12 }}
                  >
                    {column.render("Header")}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableHead>
          <TableBody component="div">
            {rows.map((row, index) => {
              prepareRow(row);
              return (
                <>
                  <CustomTableRow key={row.id} row={row.original} />
                  {row.subRows &&
                    row.subRows.map((subRow) => {
                      console.log(subRow);
                      const values = subRow.values;
                      return (
                        <TableRow>
                          <CustomTableCell
                            component="th"
                            scope="row"
                            color="#333333"
                          >
                            <SubdirectoryArrowRightIcon
                              fontSize="small"
                              style={{ color: "#CCCCCC", marginRight: "10px" }}
                            />
                            {values.enTitle}
                          </CustomTableCell>
                          <CustomTableCell align="left" color="#333333">
                            {values.tcTitle}
                          </CustomTableCell>
                          <CustomTableCell
                            align="left"
                            className={`${
                              classes.itemStatus
                            } ${values.status.toLowerCase()}`}
                          >
                            {values.status.charAt(0).toUpperCase() +
                              values.status.slice(1).toLowerCase()}
                          </CustomTableCell>
                          <CustomTableCell align="left" color="#333333">
                            {values.slug}
                          </CustomTableCell>
                        </TableRow>
                      );
                    })}
                </>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
    </>
  );
}
